import { render, staticRenderFns } from "./White.vue?vue&type=template&id=4ac10ee1&"
import script from "./White.vue?vue&type=script&lang=js&"
export * from "./White.vue?vue&type=script&lang=js&"
import style0 from "./White.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports